import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { ResourcesHubIcon } from '@rsos/assets/icons';
import { UnreadNotificationIcon } from '@rsos/components/capstone/UnreadNotificationIcon/UnreadNotificationIcon';
import { Box, Button } from '@rsos/components/capstone/base';
import {
  useHasUnreadTransportRequests,
  toggleResourcePanel,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import styles from './ResourceRequestBtn.module.css';

/**
 * Navigation button for opening the Resource Request Panel.
 * Toggles the resource panel visibility when clicked.
 */
export const ResourceRequestBtn: FunctionComponent = () => {
  const dispatch = useDispatch();
  const hasUnreadTransportRequests = useHasUnreadTransportRequests();

  const handleClick = () => {
    dispatch(toggleResourcePanel());
  };

  return (
    <Box horizontal onClick={handleClick}>
      <span className={styles.resourceRequestNavButtonContainer}>
        <Button
          btnType="tertiary"
          size="small"
          type="button"
          dataName="resource-request-nav-button"
          aria-label="Request Resources"
        >
          <ResourcesHubIcon width={16} height={16} color="secondaryText" />
          {hasUnreadTransportRequests && (
            <UnreadNotificationIcon
              aria-hidden="true"
              data-testid="resource-request-nav-icon"
            />
          )}
        </Button>
      </span>
    </Box>
  );
};

export default ResourceRequestBtn;
